module.exports = __webpack_public_path__ + "static/media/water.51906f97.svg";